import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueApexCharts from "vue3-apexcharts";
import './assets/style/grid.css'
import './assets/style/styles.scss'

const app = createApp(App)

// Настройка глобальных свойств
app.config.globalProperties.$axios = axios

// Подключение плагинов
app.use(store)
app.use(router)
app.use(VueApexCharts)

app.mount('#app')
